import "./ThinksToDo.scss";
import {
  InterviewRoundDetailsType,
  ScheduledUpcomingInterviewsListType,
} from "../../redux/thinksToDo/thinksToDoType";
import {
  CalendarClock,
  CalendarTodayGreen,
  LikeIcon,
} from "../../assets/images";
import CustomizedAvatar from "../commons/CircularAvatar/CustomizedAvatar";
import {
  formatDateAndTimeWithoutLocal,
  getTodayDateWithTimeStamp,
} from "../../utils/commonFunctions";
import { LoginResponseType } from "../../redux/auth/authTypes";
import BoxLoader from "../commons/BoxLoader/BoxLoader";

type AppProps = {
  scheduledUpcomingInterviewsList: ScheduledUpcomingInterviewsListType[] | [];
  handleFeedBackModal: (data?: string) => void;
  history: any;
  loginData: LoginResponseType;
  thinksToDoFetching: boolean;
};
const ScheduledUpcomingInterviews = ({
  scheduledUpcomingInterviewsList,
  handleFeedBackModal,
  history,
  loginData,
  thinksToDoFetching,
}: AppProps) => {
  return (
    <div
      className="boxs scheduled-upcoming-interviews"
      style={{ overflow: "auto" }}
    >
      {thinksToDoFetching ? (
        <BoxLoader style={{ height: "100%" }} />
      ) : (
        <>
          <div className="d-flex justify-content-between">
            <div
              className="p-4 d-flex align-items-center w-75"
              style={{ gap: "3%" }}
            >
              <div>
                <img src={CalendarClock} alt="calendar-clock" />
              </div>
              <div>
                <p className="m-0" style={{ color: "#7c8db0" }}>
                  RECRUITMENT TRACKER
                </p>
                <p
                  className="m-0"
                  style={{ fontSize: "14px", fontWeight: 600 }}
                >
                  Scheduled Upcoming Interviews
                </p>
              </div>
            </div>
            <div className="d-flex align-items-center p-4">
              <span
                className="mr-3"
                style={{
                  textDecoration: "underline",
                  color: "#dd4433",
                  cursor: "pointer",
                }}
                onClick={() => {
                  history.push({
                    pathname: `/things-to-do/interview-list`,
                  });
                }}
              >
                View All
              </span>
            </div>
          </div>
          <hr className="m-0"></hr>
          {scheduledUpcomingInterviewsList?.length > 0 ? (
            scheduledUpcomingInterviewsList?.map(
              (el: ScheduledUpcomingInterviewsListType) => {
                const buttonDisabled =
                  el?.interview_details?.interview_round_details?.filter(
                    (el: InterviewRoundDetailsType) => {
                      return (
                        el?.interviewer === loginData?.user_id &&
                        !el?.is_feedback_submited
                      );
                    }
                  );

                let toDayDate = getTodayDateWithTimeStamp();

                let timeCheck = false;
                if (buttonDisabled?.length > 0) {
                  timeCheck =
                    buttonDisabled[buttonDisabled?.length - 1]
                      ?.interview_date_and_time < toDayDate;
                }
                return (
                  <div>
                    <div
                      className="d-flex align-items-center p-3"
                      style={{ gap: "3%" }}
                    >
                      <div>
                        <CustomizedAvatar
                          name={`${el?.name}`}
                          image={el?.profile_pic?.file_url}
                          style={{ width: "58px", fontSize: "21px" }}
                        />
                      </div>
                      <div>
                        <p
                          className="mb-1"
                          style={{
                            fontSize: "15px",
                            fontWeight: 500,
                            textDecoration: "underline",
                            cursor: "pointer",
                          }}
                          onClick={() => handleFeedBackModal(el?._id)}
                        >
                          {el?.position_details?.job_position?.name} position in{" "}
                          {el?.position_details?.job_location?.name}.
                        </p>
                        <p
                          className="mt-0 mb-1"
                          style={{ color: "#6e7491" }}
                        >{`${el?.name} (${el?.email})`}</p>
                        <div
                          style={{
                            color: "#28a745",
                            display: "flex",
                            alignItems: "center",
                            fontWeight: 500,
                          }}
                        >
                          <img src={CalendarTodayGreen} alt="calender-icon" />{" "}
                          <div className="ml-2">
                            {formatDateAndTimeWithoutLocal(
                              el?.interview_details?.interview_round_details[
                                el?.interview_details?.interview_round_details
                                  ?.length - 1
                              ]?.interview_date_and_time?.toString()
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <button
                      className="btn btn-primary ml-5"
                      onClick={() => handleFeedBackModal(el?._id)}
                      disabled={
                        buttonDisabled?.length === 0
                          ? true
                          : buttonDisabled?.length > 0 && timeCheck
                          ? false
                          : true
                      }
                    >
                      Submit Feedback
                    </button>
                    <hr></hr>
                  </div>
                );
              }
            )
          ) : (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "70%",
                flexDirection: "column",
              }}
            >
              <img src={LikeIcon} alt="like-icon" />
              <div
                className="mt-3"
                style={{
                  fontSize: "19px",
                  fontWeight: 600,
                  textAlign: "center",
                }}
              >
                Good Work! You have no<br></br> scheduled interviews.
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default ScheduledUpcomingInterviews;
